import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// Mobile = below the `lg` breakpoint (< 992px): phones and portrait tablets.
// Keep this in sync with the `max-width: 991.98px` media queries in
// ShellV2/shell.css — both express the same boundary.
export function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("lg"));
}

// Current active breakpoint key. Calls a fixed number of hooks (one per
// breakpoint, largest first) so it satisfies the rules of hooks.
export function useBreakpoint() {
  const theme = useTheme();
  const isXxl = useMediaQuery(theme.breakpoints.up("xxl"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  const isLg = useMediaQuery(theme.breakpoints.up("lg"));
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const isSm = useMediaQuery(theme.breakpoints.up("sm"));
  if (isXxl) return "xxl";
  if (isXl) return "xl";
  if (isLg) return "lg";
  if (isMd) return "md";
  if (isSm) return "sm";
  return "xs";
}
